import Icon from 'veui/components/Icon'

Icon.register({
  'check-circle': {
    paths: [
      {
        d: 'M24 48a24 24 0 110-48 24 24 0 010 48zm0-4a20 20 0 100-40 20 20 0 000 40zm-4-14.83L34.59 14.6a2 2 0 012.82 2.82l-16 16a2 2 0 01-2.82 0l-8-8a2 2 0 012.82-2.82L20 29.17z'
      }
    ],
    width: '48',
    height: '48'
  }
})
